import { useForm } from "react-hook-form";
import { EOrderTipForm } from "../../../services/types";
import { OrderTipFormInputs } from "./OrderTipFormInputs";
import { OrderTipList } from "./OrderTipList";

export const OrderTipForm = () => {
	const form = useForm<EOrderTipForm>({
		defaultValues: {
			tip: 0,
			custom_amount: undefined,
			email: "",
		},
	});

	return (
		<>
			<OrderTipList form={form} />
			<OrderTipFormInputs form={form} />
		</>
	);
};
